import { Injectable } from '@angular/core';
import { StorageService } from '@global-service/storage';
@Injectable()
export class AdminGuard {
  constructor(private readonly storageService: StorageService) {}
  canActivate() {
    return this.storageService.getIsAdmin() || this.storageService.getIsSoporte();
  }
}
